import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import LoadsPage from "components/LoadsPage";
import {
  useAddEVDrivingLoadsMutation,
  useGetEVDrivingLoadsByCommunityIdPaginationQuery,
} from "state/evs/evApiSlice";

function ManageEVDrivingLoads({ noWrapper }) {
  const { t } = useTranslation(["internalLoads"]);
  return (
    <LoadsPage
      title={t("pages.ev_driving_loads.title")}
      subtitle={t("pages.ev_driving_loads.subtitle")}
      taskType="EV_DRIVING_LOAD"
      templateHref="/docs/template_driving_loads.csv"
      addMutation={useAddEVDrivingLoadsMutation}
      noWrapper={noWrapper}
      table={{
        query: useGetEVDrivingLoadsByCommunityIdPaginationQuery,
        resourceField: "ev_id",
        resourceLabel: t("pages.ev_driving_loads.table.columns.ev"),
        resourceType: "EV",
        valueLabel: {
          field: "driving_consumption",
          label: t("pages.ev_driving_loads.table.columns.driving_consumption"),
        },
        valueDigits: 4,
      }}
    />
  );
}

ManageEVDrivingLoads.propTypes = {
  noWrapper: PropTypes.bool,
};

ManageEVDrivingLoads.defaultProps = {
  noWrapper: false,
};

export default ManageEVDrivingLoads;
